import { Component, Input, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from "@angular/core";
import { Subscription } from "rxjs";

import { ExamService } from "src/app/services/exam.service";
import { EventsHubService, EDITORMESSAGETYPE, EditorMessage } from "src/app/services/eventshub.service";
import { PageObjectContainer } from "src/app/models/pageobjectcontainer";
import { Exam } from "src/app/models/exam";
import { PageObject } from "src/app/models/pageobject";

@Component({
  selector: "hkt-pageobjectcontainer",
  templateUrl: "./pageobjectcontainer.component.html",
  styleUrls: ["./pageobjectcontainer.component.scss"],
})
export class PageObjectContainerComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild("innerContainer") innerContainer: ElementRef;
  @Input("obj") obj: PageObjectContainer;
  @Input("mode") mode: string;
  @Input("pageScale") pageScale: number;

  exam: Exam;
  examSubscription: Subscription;
  selectedObject: PageObject;
  eventsHubSubscription: Subscription;

  constructor(private examService: ExamService, private eventsHubService: EventsHubService) {
    this.mode = "exam";
    this.selectedObject = null;

    this.eventsHubSubscription = this.eventsHubService.onEditorMessage.subscribe(msg => {
      if (msg.type == EDITORMESSAGETYPE.SelectPage) {
        this.selectedObject = null;
      } else if (msg.type == EDITORMESSAGETYPE.SelectObject) {
        this.selectedObjectIfOwned(msg.data);
      }
    });
  }

  ngOnInit(): void {
    this.exam = this.examService.currentExam;
    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => (this.exam = exam));
  }

  ngOnDestroy(): void {
    this.examSubscription.unsubscribe();
    this.eventsHubSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    // this.innerContainer.nativeElement.onscroll(() => console.log("asdasd"));
  }

  onScroll(event: Event): void {
    this.obj.containerOffsetX = (<any>event.target).scrollLeft;
    this.obj.containerOffsetY = (<any>event.target).scrollTop;
  }

  onSelectObject(event: MouseEvent, obj: PageObject) {
    if (this.mode != "edit") {
      return;
    }

    let msg = new EditorMessage();
    msg.type = EDITORMESSAGETYPE.SelectObject;
    msg.data = obj;
    this.eventsHubService.setEditorMessage(msg);

    event.stopPropagation();
  }

  private selectedObjectIfOwned(obj: PageObject): void {
    for (let i = 0; i < this.obj.objects.length; i++) {
      if (this.obj.objects[i] == obj) {
        this.selectedObject = obj;
        return;
      }
    }
    this.selectedObject = null;
  }
}
